<template>
  <div class="wrapper">
    <div class="form-wrapper">
      <div class="banner">
        <h1>易售云生产平台</h1>
      </div>

      <el-form :rules="rules" :model="loginForm" ref="loginForm">

        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名称"
            @keyup.enter.native="submit('loginForm')" >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            type="password"
            size="large"
            placeholder="请输入用户密码"
            v-model="loginForm.password"
            @keyup.enter.native="submit('loginForm')">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
      </el-form>

      <div class="submit">
        <el-button
          type="primary"
          style="width: 100%"
          @click="submit('loginForm')">
          登录
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { md5 } from '@/utils/crypto'

export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions('opUser', [
      'login'
    ]),
    submit (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.login({
            username: this.loginForm.username,
            password: md5(this.loginForm.password)
          }).then(res => {
            this.$message({
              message: '登录成功',
              type: 'success'
            })
            this.$router.push({
              name: 'Welcome'
            })
          }).catch(err => {
            console.log(err)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/base";

.wrapper {
  height: 100vh;
  width: 100vw;
  background: $primaryColor;

  .form-wrapper {
    background: #FFFFFF;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 3rem 0;
    text-align:center;
    border-radius: 4px;
    box-shadow: 0 1px 10px 1px #000000aa;
    min-width: 28rem;

    .banner {
      color: $darkPrimaryColor;
    }

    form {
      width: 80%;
      margin: 2rem auto;

      .el-input {
        background: #ffffff;
      }
    }

    .submit {
      width: 80%;
      margin: 1rem auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue